export default {
    namespaced: true,
    state: {
        /** show nav bars **/
        showLeftBar: false,
    },
    getters: {
        /** show nav bars **/
        getShowLeftBar: state => {
            return state.showLeftBar;
        },
    },
    mutations: {
        /** change nav bars **/
        changeShowLeftBar: state => {
            state.showLeftBar = !state.showLeftBar;
        },
        setShowLeftBar: (state, data) => {
            state.showLeftBar = data;
        },
    },
    actions: {
        /** show nav bars **/
        changeShowLeftBar: context => {
            context.commit('changeShowLeftBar');
        },
        setShowLeftBar: (context, data) => {
            context.commit('setShowLeftBar', data);
        },
    },
};
